import React, { useEffect, useState, Fragment } from "react";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import {
  convertFormData,
  formToQueryString,
  getMailProcessData,
} from "../../../../../_helpers/_utils/utils";
import {
  addNewActivity,
  deleteCommunication,
  getAllActivities,
  updateActivity,
} from "../../../../../GeneralApi/GeneralApi";
import AddToMail from "../../../../../partials/component/addToMail/AddToMail";
import DefaultModal from "../../../../../partials/modal/DefaultModal";
import ThemeHeader from "../../../../../partials/content/ThemeHeader";
import ThemeButton from "../../../../../partials/button/ThemeButton";
import DynamicTableEdit from "../../../../../partials/table/DynamicTableEdit";
import { toast } from "react-toastify";
import AccessControl from "../../../../../_ accessControl/AccessControl";

const ProspectMail = ({ edit, profileId, profile }) => {
  const [items, setItems] = useState([]);
  const [otherResData, setOtherResData] = useState(null);
  const [showAddEmail, setShowAddEmail] = useState(false);
  const [showRowOnClick, setShowRowOnClick] = useState(false);
  const [rowOnClickData, setRowOnClickData] = useState(null);
  const [selectedRow, setSelectedRow] = useState([{}]);

  // setItems(data.data);
  console.log(edit);
  useEffect(() => {
    update();
  }, [profileId]);

  const update = (value) => {
    let obj = {};
    if (value?.page) {
      obj.page = value.page;
    }
    obj.prospect = profileId;
    obj.limit = 20;
    let query = formToQueryString(obj);
    if (profileId) {
      getAllActivities(query)
        .then((res) => {
          const { data, ...rest } = res.data;

          if (value?.loadMore) {
            setItems(items?.concat(rest));
          } else {
            setItems(data);
          }
          setOtherResData(rest);
        })
        .catch(() => {});
    }
  };

  console.log(items);
  const fetchMoreData = () => {
    // let obj = {};
    // obj.prospect = profileId;
    // obj.page = otherResData.current_page + 1;
    // obj.limit = 20;
    // let query = formToQueryString(obj);
    if (otherResData?.next_page_url) {
      update({ page: otherResData.current_page + 1, loadMore: true });
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Mail",
        columns: [
          {
            Header: "Date",
            accessor: "created_at",
            Cell: ({ cell: { value } }) => (
              <p className="text-center">
                {moment(value).format("DD/MM/YYYY")}
              </p>
            ),
          },
          {
            Header: "Time",
            accessor: "id",
            Cell: ({
              cell: {
                row: { original },
              },
            }) => (
              <p className="text-center">
                {moment(original.created_at).format("LT")}
              </p>
            ),
          },
          {
            Header: "By",
            accessor: "contact",
            Cell: ({
              cell: {
                row: { original },
              },
            }) => (
              <p className="text-center">
                {console.log(original)}
                {original?.initial}
              </p>
            ),
          },
          {
            Header: "Type",
            accessor: "type",
            Cell: ({
              cell: {
                row: { original },
              },
            }) => (
              <p className="text-center">
                {original?.type?.[0]?.id === 1 ? (
                  <i className="fas fa-mobile    "></i>
                ) : (
                  <i className="fa fa-envelope-open" aria-hidden="true"></i>
                )}
              </p>
            ),
          },
          {
            Header: "Subject",
            accessor: "subject",
            Cell: ({
              cell: {
                row: { original },
              },
            }) => (
              <p>
                {original?.email
                  ? original.email.email_subject
                  : original?.sms
                  ? original?.sms?.content?.substr(3).slice(0, -4)
                  : ""}
              </p>
            ),
          },
        ],
      },
    ],
    []
  );

  const rowClick = (e) => {
    setRowOnClickData(e);
    setShowRowOnClick(!showRowOnClick);
  };

  const handleMailAdd = (e) => {
    const { email_subject, content, type, ...others } = e;
    let formData = { ...others };
    if (type == 2) {
      formData.email = { content: content, email_subject: email_subject };
    }
    if (type == 1) {
      formData.sms = { content: content };
    }
    formData.type = type;
    formData.buyer = profileId;
    formData.created_manually = 1;
    formData = convertFormData(formData);

    if (e.id) {
      formData.append("_method", "PATCH");
      updateActivity(e.id, formData)
        .then(({ data }) => {
          toast.success("Mail Edited Successfully");
          setShowAddEmail(false);
          update();
        })
        .catch((e) => {
          toast.error("Error while saving");
        });
    } else {
      addNewActivity(formData)
        .then(({ data }) => {
          toast.success("Mail Added Successfully");
          setShowAddEmail(false);
          update();
        })
        .catch((e) => {
          toast.error("Error while saving");
        });
      console.log(...formData, "formm");
    }

    //
  };

  const handleRemove = () => {
    selectedRow.map((item) => {
      deleteCommunication(item.id)
        .then(({ data }) => {
          update();
        })
        .catch((e) => {
          toast.error("Error while Deleting");
        });
    });
  };
  const datas = React.useMemo(() => items, [items]);

  return (
    <div>
      {showAddEmail ? (
        <DefaultModal
          size="xl"
          centered
          show={showAddEmail}
          onHide={() => setShowAddEmail(false)}
        >
          <AddToMail
            onHide={() => setShowAddEmail(false)}
            onSubmit={handleMailAdd}
            currentContact={profile.contacts?.map((contact) => {
              return {
                name: contact.first_name + " " + contact.last_name,
                id: contact.id,
              };
            })}
          />
        </DefaultModal>
      ) : (
        ""
      )}

      {showRowOnClick ? (
        <DefaultModal
          size="xl"
          centered
          show={showRowOnClick}
          onHide={() => setShowRowOnClick(false)}
        >
          <AddToMail
            initialValues={getMailProcessData(rowOnClickData)}
            clickData={rowOnClickData}
            onHide={() => setShowRowOnClick(false)}
            onSubmit={handleMailAdd}
            currentContact={profile.contacts?.map((contact) => {
              return {
                name: contact.first_name + " " + contact.last_name,
                id: contact.id,
              };
            })}
          />
        </DefaultModal>
      ) : (
        ""
      )}

      <ThemeHeader
        right={
          <Fragment>
            <AccessControl
              allowedPermissions={["prospects-download"]}
              renderNoAccess={() => ""}
            >
              <ThemeButton
                icon
                className="mr-2 lightGrey-button-icon"
                // OnClick={() => setDeleteItem((prev) => prev + 1)}
              >
                <i className="fas fa-download    "></i>{" "}
              </ThemeButton>
            </AccessControl>

            <ThemeButton
              className="mr-2 lightGrey-button font-weight-bold"
              onClick={() => handleRemove()}
              disabled={!selectedRow.length}
            >
              Remove{" "}
            </ThemeButton>
            <ThemeButton
              onClick={() => setShowAddEmail(true)}
              className=" green-button font-weight-bold"
            >
              Add
            </ThemeButton>
          </Fragment>
        }
      />
      <div className="mail-log-table">
        {datas ? (
          <DynamicTableEdit
            allSelected={(e) => console.log(e.target.checked)}
            handleChange={(e) =>
              setSelectedRow(e.filter((obj) => obj.created_manually))
            }
            // isEditable="false"
            isEditable={true}
            isConditional
            columns={columns}
            data={datas}
            update={fetchMoreData}
            handleRowClick={rowClick}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ProspectMail;
